import React from 'react';
import DescriptorDropdown from '../DescriptorDropdown';
import { processTranscriptsWithFrequencies } from 'utils/filterDataProcessors';

/**
 * Component for displaying and managing transcript filters
 */
const TranscriptsFilter = ({
  transcripts,
  filters,
  filterReport,
  onToggleTranscript,
  onClearTranscripts,
  onApplyFilter,
  dropdownAbove,
  transcriptFilterButtonText,
  transcriptSubHeader,
  defaultOpen = false,
  onDeleteFilter
}) => {
  const transcriptsWithFrequencies = processTranscriptsWithFrequencies(
    transcripts, filters, filterReport
  );

  return (
    <DescriptorDropdown
      name="Transcripts"
      codes={transcriptsWithFrequencies}
      onChecked={onToggleTranscript}
      onClearChecked={onClearTranscripts}
      applyFilter={onApplyFilter}
      dropdownAbove={dropdownAbove}
      filterButtonText={transcriptFilterButtonText}
      subHeader={transcriptSubHeader}
      defaultOpen={defaultOpen}
      onDeleteFilter={onDeleteFilter}
    />
  );
};

export default TranscriptsFilter;
